// 配信元が Content-Disposition: attachment で返す URL を開き、ページ遷移せずに保存させる。
// fetch で取得すると、リダイレクト先の Cloud Storage が CORS を許可していない環境で失敗するため使わない。
export const downloadFile = (url: string): void => {
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.rel = 'noopener';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
};
